module.exports = __webpack_public_path__ + "static/media/iso-blue.fae709c0.svg";